// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  ICianApiSiteV1GetBsCenterInfoRequest,
  TCianApiSiteV1GetBsCenterInfoModel,
  IMappers,
  TCianApiSiteV1GetBsCenterInfoResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IBSCenterResponseSchema91 } from '../../../../entities/schemas/BSCenterResponseSchema91';
import type { IErrorResponseSchema92 } from '../../../../entities/schemas/ErrorResponseSchema92';
import type { IErrorResponseSchema93 } from '../../../../entities/schemas/ErrorResponseSchema93';

export function createCianApiSiteV1GetBsCenterInfoModel(
  parameters: ICianApiSiteV1GetBsCenterInfoRequest,
): TCianApiSiteV1GetBsCenterInfoModel {
  return {
    v: 1,
    apiType: 'legacy',
    method: 'GET',
    microserviceName: 'monolith-python',
    pathApi: '/cian-api/site/v1/get-bs-center-info/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
      404: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface ICianApiSiteV1GetBsCenterInfoOptions<TResponse200, TResponse400, TResponse404> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400, TResponse404>;
  parameters: ICianApiSiteV1GetBsCenterInfoRequest;
}

export async function fetchCianApiSiteV1GetBsCenterInfo<TResponse200, TResponse400, TResponse404>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICianApiSiteV1GetBsCenterInfoOptions<TResponse200, TResponse400, TResponse404>): Promise<
  FetchResponse<TCianApiSiteV1GetBsCenterInfoResponse> | TResponse200 | TResponse400 | TResponse404
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCianApiSiteV1GetBsCenterInfoModel(parameters),
    config,
  )) as FetchResponse<TCianApiSiteV1GetBsCenterInfoResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IBSCenterResponseSchema91, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema92, headers);
    }
    if (statusCode === 404) {
      return mappers[404](response as IErrorResponseSchema93, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCianApiSiteV1GetBsCenterInfoResponse>;
}
